import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import env from 'enviro';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { signupEligibleProductLines } from 'pricing-pages-lib/constants/SignupEligibleProductLines';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import { getGAClassName, getHubsSignupCTA, getHubsSignupUrl } from 'pricing-pages-lib/utils/publicPageUrls';
import { getSavedQueryParamString } from 'pricing-pages-lib/utils/queryParamUtils';
import { useSelector } from 'react-redux';
import { CMS, MARKETING, SALES, SERVICE } from 'self-service-api/constants/ProductLines';
import { Flow } from 'signup-constants/Flow';
import { SignupUrlGenerator } from 'signup-ui-url-generator/SignupUrlGenerator';
import partial from 'transmute/partial';
import UIButton from 'UIComponents/button/UIButton';
import { omit } from 'underscore';
import { isAppAuthSelector } from '../../selectors/AuthSelectors';
import { SIGNUP } from 'pricing-pages-lib/constants/CtaTypes';
import { Metrics } from 'pricing-pages-ui/utils/metrics';
import { isUngatedForSeatsSelector } from '../../selectors/GatingSelectors';
const ELIGIBLE_PRODUCT_LINES_TO_SIGNUP = {
  [MARKETING]: Flow.Marketing,
  [SALES]: Flow.Sales,
  [SERVICE]: Flow.Service,
  [CMS]: Flow.CmsFree
}; // Not to be confused  with hubs signup url, this is the actual URL
// of the signup app we're sending the user to

function getSignupUrl(signupType) {
  return new SignupUrlGenerator(signupType !== 'crm' && Object.keys(ELIGIBLE_PRODUCT_LINES_TO_SIGNUP).includes(signupType) ? ELIGIBLE_PRODUCT_LINES_TO_SIGNUP[signupType] : Flow.Crm, {
    query: {},
    env: env.isQa() ? 'qa' : 'prod'
  }).getUrl();
}

const trackClick = (sourceId, signupType) => {
  getUsageTracker().track('signupClick', {
    sourceId,
    signupType
  });
  Metrics.counter('signup-clicked').increment();
};

const SignupButton = (_ref) => {
  let {
    sourceId,
    productLine,
    className,
    use = 'primary',
    ctaKey = 'pricingPage.signupCtas.getStartedFree',
    style
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["sourceId", "productLine", "className", "use", "ctaKey", "style"]);

  const hubsSignupUrl = getHubsSignupUrl({});
  const isUngatedForSeats = useSelector(isUngatedForSeatsSelector);
  const signupType = 'crm' === productLine || !signupEligibleProductLines.includes(productLine) ? 'crm' : productLine;
  const hubsSignupCta = getHubsSignupCTA({
    ctaType: SIGNUP,
    sourceId,
    productLine
  });
  const gaClassName = getGAClassName(hubsSignupCta);
  const hubsParamString = getSavedQueryParamString() && `&${getSavedQueryParamString()}`;
  const HREF = `${getSignupUrl(signupType)}?hubs_signup-url=${hubsSignupUrl}&hubs_signup-cta=${hubsSignupCta}${hubsParamString}&hsSeats=${isUngatedForSeats}`;
  const isInApp = useSelector(isAppAuthSelector);
  const propsToPass = omit(rest, ['dispatch']);
  return /*#__PURE__*/_jsx(UIButton, Object.assign({
    use: use,
    href: isInApp ? null : HREF,
    className: `${gaClassName} ${className}`,
    disabled: isInApp,
    onClick: partial(trackClick, sourceId, signupType),
    style: style
  }, propsToPass, {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: ctaKey,
      className: gaClassName
    })
  }));
};

export default SignupButton;